import { ConfigStateService, RoutesService, eLayoutType } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { syncRoutesWithFeature } from './shared/routes/feature-routes.util';

export const APP_ROUTE_PROVIDER = [
  {
    provide: APP_INITIALIZER,
    useFactory: configureRoutes,
    deps: [RoutesService, ConfigStateService],
    multi: true,
  },
];

export function configureRoutes(routes: RoutesService, configState: ConfigStateService) {
  return () => {
    routes.add([
      /*
      {
        path: '/',
        name: '::Menu:Home',
        iconClass: 'fas fa-home',
        order: 2,
        layout: eLayoutType.application,
      },
      */
      {
        path: '/clientes',
        name: 'Clientes',
        iconClass: 'fas fa-building',
        // 100, não 101: config-menu.service patcheia a Administração para 101 e o RoutesService
        // desempata pela ordem de inserção, que não é a mesma no boot frio e no login por SPA.
        order: 100,
        layout: eLayoutType.application,
        requiredPolicy: 'cargo_fleet.Clientes.Host',
        invisible: false,
      },
      {
        // Item próprio, NÃO filho de Clientes: no LeptonX um item pai com filhos perde o próprio link
        // (AbpNavbarService em @volo/abp.ng.lepton-x.core: `link: route.children?.length ? undefined : route.path`),
        // e "Clientes" virou um menu suspenso sem destino em produção (07/10/2026). Ordem 100.5 = logo
        // depois de Clientes (100) e antes da Administração (101, patcheada em config-menu.service). Só host vê.
        path: '/radar-acessos',
        name: 'Radar de acessos',
        iconClass: 'fas fa-map-marked-alt',
        order: 100.5,
        layout: eLayoutType.application,
        requiredPolicy: 'cargo_fleet.RadarAcessos.Host',
        invisible: false,
      },
      {
        path: '/metricas-dashboard',
        name: 'Métricas',
        iconClass: 'fas fa-tachometer-alt',
        order: 102,
        layout: eLayoutType.application,
        requiredPolicy: 'cargo_fleet.Metricas.Host',
        invisible: false,
      },
      {
        path: "/privacy-policy",
        name: 'Políticas de Privacidade',
        iconClass: 'fas fa-cahrt line',
        order: 200,
        layout: eLayoutType.empty,
        invisible: true
      }

    ]);

    // O Painel agrega ofertas — é a home do módulo Leilão e acompanha a feature dele.
    syncRoutesWithFeature(routes, configState, 'cargo_fleet.Leilao', [
      {
        path: '/dashboard',
        name: '::Menu:Dashboard',
        iconClass: 'fas fa-chart-line',
        order: 5,
        layout: eLayoutType.application,
        requiredPolicy: 'cargo_fleet.Dashboard.Host  || cargo_fleet.Dashboard.Tenant',
        invisible: false,
      },
    ]);
  };
}
